import { supabase } from '../lib/supabase';

export const dailyRecordService = {
  async getOrCreateDailyRecord(userId, siteId, companyId, recordDate) {
    try {
      const { data, error } = await supabase
        ?.rpc('get_or_create_daily_record', {
          p_user_id: userId,
          p_site_id: siteId,
          p_company_id: companyId,
          p_record_date: recordDate
        });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error: { message: error?.message } };
    }
  },

  async markNothingToReport(dailyRecordId) {
    try {
      const { data, error } = await supabase
        ?.from('daily_site_records')
        ?.update({
          nothing_to_report: true,
          updated_at: new Date()?.toISOString()
        })
        ?.eq('id', dailyRecordId)
        ?.select()
        ?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error: { message: error?.message } };
    }
  },

  async uploadDailyPhoto(dailyRecordId, file, caption = '') {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const fileExt = file?.name?.split('.')?.pop();
      const fileName = `daily-records/${dailyRecordId}/${Date.now()}.${fileExt}`;

      const { error: uploadError } = await supabase?.storage
        ?.from('site-documents')
        ?.upload(fileName, file);

      if (uploadError) throw uploadError;

      const { data, error } = await supabase
        ?.from('daily_site_photos')
        ?.insert({
          daily_record_id: dailyRecordId,
          file_path: fileName,
          caption: caption,
          uploaded_by: user?.id
        })
        ?.select()
        ?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error: { message: error?.message } };
    }
  },

  async getDailyRecordPhotos(dailyRecordId) {
    try {
      const { data, error } = await supabase
        ?.from('daily_site_photos')
        ?.select('*')
        ?.eq('daily_record_id', dailyRecordId)
        ?.order('created_at', { ascending: false });

      if (error) throw error;
      return { data: data || [], error: null };
    } catch (error) {
      return { data: [], error: { message: error?.message } };
    }
  },

  async getDailyRecord(userId, siteId, recordDate, options = {}) {
    const { includeDeleted = false } = options;
    try {
      let query = supabase
        ?.from('daily_site_records')
        ?.select('*')
        ?.eq('user_id', userId)
        ?.eq('site_id', siteId)
        ?.eq('record_date', recordDate);
      // NSherjFh PR 6: skip soft-deleted records by default. Matches
      // the get_or_create_daily_record RPC, which was updated in the
      // same migration to filter deleted_at IS NULL in its SELECT.
      if (!includeDeleted) query = query?.is('deleted_at', null);
      const { data, error } = await query?.single();

      if (error && error?.code !== 'PGRST116') throw error;
      return { data: data || null, error: null };
    } catch (error) {
      return { data: null, error: { message: error?.message } };
    }
  }
};